module.exports = __webpack_public_path__ + "static/media/logo.f733fa74.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo.svg
// module id = 400
// module chunks = 28